import { useCallback, useState } from 'react'
import { lerRecentes, registrarRecente } from '../../dominio/tabletop/recentes'
import type { TipoObjetoTabletop } from '../../dominio/tabletop/tipos'

const CHAVE = 'bizu-tabletop-recentes'

function ler(): TipoObjetoTabletop[] {
  try {
    return lerRecentes(window.localStorage.getItem(CHAVE))
  } catch {
    return []
  }
}

/** Os últimos tipos de peça adicionados, guardados no navegador. */
export function useRecentes() {
  const [recentes, setRecentes] = useState<TipoObjetoTabletop[]>(ler)
  const registrar = useCallback((tipo: TipoObjetoTabletop) => {
    setRecentes((atual) => {
      const novo = registrarRecente(atual, tipo)
      try {
        window.localStorage.setItem(CHAVE, JSON.stringify(novo))
      } catch {
        /* sem armazenamento: a lista vale só nesta sessão */
      }
      return novo
    })
  }, [])
  return { recentes, registrar }
}
